import { history } from '~/constants';
import { AppState, Auth0ProviderOptions } from '@auth0/auth0-react';
import posthog from 'posthog-js';
import { StepStatus } from '~/enums';
import { captureAuth0AuthStep } from '~/helpers/auth0Telemetry';

const onRedirectCallback = (appState: AppState) => {
  // Use the router's history module to replace the urls
  const { pathname, search } = history.location;

  const { hash, market, returnTo } = appState || {};
  const sessionReturnTo = sessionStorage.getItem('returnTo');

  posthog.capture('myqred_login', {
    state: 'authenticated_on_redirect',
  });

  if (hash && market) {
    history.replace({ pathname, search, state: { hash, market } });
    return;
  }

  captureAuth0AuthStep({
    stepName: 'on_redirect_callback',
    stepStatus: StepStatus.Started,
    properties: {
      appStateReturnTo: returnTo,
      sessionReturnTo,
    },
  });

  const newUrl = new URL(window.location.href);

  newUrl.searchParams.delete('code');
  newUrl.searchParams.delete('state');

  if (returnTo) {
    const returnToPathname = returnTo.split('?')[0];
    const returnToSearch = returnTo.split('?')[1];
    newUrl.pathname = returnToPathname;
    if (returnToSearch) {
      newUrl.search = returnToSearch;
    }

    sessionStorage.removeItem('returnTo');
  }

  captureAuth0AuthStep({
    stepName: 'on_redirect_callback',
    stepStatus: StepStatus.Finished,
    properties: {
      appStateReturnTo: returnTo,
      sessionReturnTo,
      resolvedPathname: newUrl.pathname,
    },
  });

  history.replace({
    pathname: newUrl.pathname,
    search: newUrl.search,
  });
};
export const getCookieDomain = (hostname: string, mode: string): string => {
  if (mode === 'production' || mode === 'internal-prod') {
    // Set cookie domain to .qred.com to share cookies across subdomains
    // e.g. if the hostname is my.qred.com, we want to set the cookie domain to .qred.com
    return `.${hostname.split('.').slice(-2).join('.')}`;
  }
  if (mode === 'test' && hostname !== 'localhost') {
    // Set cookie domain to the last 3 parts of the hostname to share cookies across subdomains
    // e.g. if the hostname is my.test.qred.com, we want to set the cookie domain to .test.qred.com
    return `.${hostname.split('.').slice(-3).join('.')}`;
  }
  return hostname;
};

const cookieDomain = getCookieDomain(
  globalThis.location.hostname,
  import.meta.env.MODE
);

const auth0Config: Auth0ProviderOptions = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin + '/login',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
  cacheLocation: window.Cypress && 'localstorage',
  onRedirectCallback,
  cookieDomain,
};

export default auth0Config;
